import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { storeLogin, getStoreToken } from './storeApi';
import './store.css';

export default function StoreLogin() {
  const [franchiseId, setFranchiseId] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (getStoreToken()) nav('/store/catalogue');
  }, [nav]);

  function submit(e) {
    e.preventDefault();
    if (!franchiseId.trim() || !password) {
      toast.error('Enter franchise ID and password');
      return;
    }
    setBusy(true);
    storeLogin(franchiseId.trim(), password)
      .then((d) => {
        toast.success(`Welcome, ${d.store.name}`);
        if (d.store.force_password_reset) {
          nav('/store/change-password');
        } else {
          nav('/store/catalogue');
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.detail || 'Login failed');
      })
      .finally(() => setBusy(false));
  }

  return (
    <div className="store-portal min-h-screen flex items-center justify-center p-6"
         data-testid="store-login-page">
      <div className="w-full max-w-md store-card p-8 sm:p-10">
        <div className="text-center mb-8">
          <h1 className="store-headline text-4xl sm:text-5xl font-bold text-orange-700 tracking-wide mb-1">OLTOWNS</h1>
          <p className="text-base sm:text-lg text-slate-600 font-medium">Store Portal</p>
          <p className="text-sm text-slate-500 mt-2">Sign in with your franchise credentials</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-600 uppercase tracking-wide">Franchise ID</label>
            <input
              className="store-input mt-1"
              placeholder="FRN-XXXX-NNNNNN"
              value={franchiseId}
              onChange={(e) => setFranchiseId(e.target.value)}
              data-testid="store-login-franchise-id"
              autoFocus
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 uppercase tracking-wide">Password</label>
            <input
              type="password"
              className="store-input mt-1"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="store-login-password"
            />
          </div>
          <button type="submit" className="store-btn-primary w-full" disabled={busy}
                  data-testid="store-login-submit">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="mt-6 text-center text-xs text-slate-400">
          Forgot password? Contact your administrator. <br />
          <Link to="/login" className="text-orange-700 underline">ERP staff login</Link>
        </div>
      </div>
    </div>
  );
}
